export function chatModelSupportsVision(model?: string | null): boolean {
  if (!model)
  {
    return false;
  }

  return model.trim().toLowerCase().startsWith('gpt-4o');
}
